import { mergeApplicationConfig } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { Amplify } from 'aws-amplify';
import config from './amplifyconfiguration.json';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { browserConfig } from './app/app.config.browser';

Amplify.configure(config);

bootstrapApplication(
  AppComponent,
  mergeApplicationConfig(appConfig, browserConfig),
).catch((err) => console.error(err));
